import script from "./SeguradoraRepository.vue?vue&type=script&lang=js"
export * from "./SeguradoraRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__